import { ITreeNode } from '@designable/core';
function updateChildBoxWithFormily(tree: ITreeNode, newChildren: ITreeNode[]) {
  const findAndUpdate = (node: ITreeNode): boolean => {
    if (node.props?.['x-component'] === 'ChildBox') {
      if (!node.children) {
        node.children = [];
      }
      node.children.push(...newChildren);
      return true;
    }
    
    if (node.children) {
      for (const child of node.children) {
        if (findAndUpdate(child)) {
          return true;
        }
      }
    }
    
    return false;
  };
  
  const isSucess = findAndUpdate(tree);
  if(!isSucess) return false;
  return tree;
}

export default updateChildBoxWithFormily;